import gql from 'graphql-tag';
import { parseToMutationRequest } from '../../../utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, []);
  let newData = dataCreate.replace('{countryCodesConfig: ', '');
  newData = `${newData.substring(0, newData.length - 1)}`;
  const createConfigCountryCode = `createConfigCountryCode(input: ${newData})`;
  return gql`
  mutation {
    ${createConfigCountryCode} {
      isdcode
    }
  }
`;
};
